import {GET, PATCH} from '@/serviceImpl/HttpFetch';
import {Profile} from '@/domain/entities/Profile';
import Clas, {DashboardData, FilteredPrecinctsType, FilterGroup, Manifest} from '@/domain/services/Clas';
import {Precinct} from '@/domain/entities/Precinct';
import {getUrlWithParamsFromObject} from '@/domain/useCases/getUrlWithParamsFromObject';
import {Parcel} from '@/domain/entities/Parcel';

const API_URL = process.env.BASE_URL;

const manifest = async (token: string): Promise<Manifest> =>
  GET<Manifest, { token: string }>(
    `${API_URL}/summaries/manifest/`,
    token
  );

const profile = async (token: string): Promise<Profile>=>
  GET<Profile, {token: string}>(
    `${API_URL}/auth/users/me/`, 
    token
  );

const getPrecinctByPointOfInterest = async (year: number, pointOfInterest: string, token: string): Promise<Array<Precinct>> =>
  GET<Array<Precinct>, { token: string }>(
    `${API_URL}/precincts?pointOfInterest=${pointOfInterest}&year=${year}`,
    token
  );

const getParcelByPointOfInterest = async (year: number, pointOfInterest: string, token: string): Promise<Array<Parcel>> =>
  GET<Array<Parcel>, { token: string }>(
    `${API_URL}/parcels?pointOfInterest=${pointOfInterest}&year=${year}`,
    token
  );

const getDashboardData = async (year: number, filterGroup: FilterGroup, token: string): Promise<DashboardData> =>
  GET<DashboardData, {token: string}>(
    getUrlWithParamsFromObject(`${API_URL}/summaries/dashboard?year=${year}`, filterGroup, true),
    token
  );

const editPrecinct = async (newPrecinct: Partial<Precinct>, token: string): Promise<Partial<Precinct>> =>
  PATCH<Partial<Precinct>, Partial<Precinct>>(
    `${API_URL}/precincts/${newPrecinct.id}`,
    newPrecinct,
    token
  );

const getFilteredPrecincts = async (year: number, filterGroup: FilterGroup, token: string): Promise<FilteredPrecinctsType> =>
  GET<FilteredPrecinctsType, {filterGroup: FilterGroup, token: string}>(
    getUrlWithParamsFromObject(`${API_URL}/summaries/precincts?year=${year}`, filterGroup, true),
    token
  );

const getUsers = async (token: string): Promise<Array<Profile>> =>
  GET<Array<Profile>, {token: string}>(
    `${API_URL}/auth/users/`,
    token
  );

const ClasImpl: Clas = {
  manifest,
  profile,
  getPrecinctByPointOfInterest,
  getParcelByPointOfInterest,
  editPrecinct,
  getDashboardData,
  getFilteredPrecincts,
  getUsers
};

export default ClasImpl;